import React from "react"
import Item from './item-card.js';
import ItemPP from './pp-item-card.js';
import { useParams } from 'react-router-dom';

function ItemList(props) {
  const { accessType, accessValue } = useParams();
  const params = [accessType, accessValue];

  const getCartQty = (id) => {
    let cartQty = null;

    if (props.cartItems && props.cartItems.products) {
      props.cartItems.products.forEach((cartItem) => {
        if (cartItem.ci_artid === id) {
          cartQty = cartItem.ci_cant;
        }
      });
    }


    return cartQty;
  }

  const dataTable = () => {
    if (props.items && props.items.length > 0) {
      if (!props.planetPlus) {
        return props.items.map((data, i) => {
          return (
            <Item
              params={params}
              loggedInChecked={props.loggedInChecked}
              deleteWishlistItem={props.deleteWishlistItem}
              toastWishlist={props.toastWishlist}
              wishlistItem={props.wishlistItems}
              rowSize={props.rowSize}
              key={i}
              itemData={data}
              itemId={data.id}
              addWishlistItem={props.addWishlistItem}
              onCartChange={props.onCartChange}
              toastCart={props.toastCart}
              interactive={props.interactive}
              textOverflow={props.textOverflow}
              cartQty={getCartQty(data.id)}
              forCarousel={props.forCarousel}
            />
          );
        });
      } else {
        return props.items.map((data, i) => {
          return (
            <ItemPP
              params={params}
              loggedInChecked={props.loggedInChecked}
              deleteWishlistItem={props.deleteWishlistItem}
              toastWishlist={props.toastWishlist}
              wishlistItem={props.wishlistItems}
              rowSize={props.rowSize}
              key={i}
              itemData={data}
              addWishlistItem={props.addWishlistItem}
              onCartChange={props.onCartChange}
              toastCart={props.toastCart}
              interactive={true}
              cartQty={getCartQty(data.ppa_artid)}
              forCarousel={props.forCarousel}
            />
          );
        });
      }
    } else {
      return null;
    }
  };


  return (
    <>
      {dataTable()}
    </>
  );
}

export default ItemList;
